<template>
  <div class="inputer-date">
    <div class="holder" :class="{ show: showed }">
      <div class="prev" @click="prev" title="Předchozí měsíc">
        <i class="fas fa-chevron-left"></i>
      </div>
      <div class="next" @click="next" title="Další měsíc">
        <i class="fas fa-chevron-right"></i>
      </div>
      <div class="label">{{ label }}</div>
      <div class="calendar">
        <div
          v-for="(wd_label, index) in labelsCalendar"
          :key="index"
          :class="`wd-label wd-${index}`"
        >{{ wd_label }}</div>
        <div
          v-for="(day) in daysCalendar"
          :key="day.getTime()"
          :class="wdClass(day)"
          @click="select(day)"
        >{{ day.getDate() }}</div>
      </div>
      <div v-if="time" class="time">
        <div
          v-for="hour in 24"
          :key="`hour-${hour-1}`"
          @click="selectHour(hour-1)"
          :class="`hour hour-${hour-1} ${value != null && hour - 1 == value.getHours() ? 'selected' : ''}`"
        >{{ hour-1 }}</div>
        <div
          v-for="minute in 60"
          :key="`minute-${minute-1}`"
          @click="selectMinute(minute-1)"
          :class="{
            minute: true,
            [`minute-${minute-1}`]: true,
            selected: value != null && minute - 1 == value.getMinutes(),
            hidden: (minute - 1) % 5 != 0,
          }"
        >{{ minute-1 }}</div>
      </div>
    </div>
    <input type="text" @focus="show" @click="show" @input="keypressed" :value="inputValue" :disabled="disabled" :data-paths="paths" />
    <div v-if="changed" class="changed" title="Neuložená změna">
      <i class="fa fa-wrench" />
    </div>
  </div>
</template>

<script>
import { datetime } from "../store_utils";
import { events } from "../extend";

export default {
  name: "inputer-date",
  props: {
    name: {},
    paths: {},
    disabled: { default: false },
    required: { default: false },
    time: { default: false }
  },
  data: () => ({
    localize: "cs-CZ",
    startWeekDay: 1,
    showed: false,
    labels: [],
    days: [],
    currentCalendar: null
  }),
  computed: {
    toS() {
      return this.time
        ? datetime.datetimeToCzechString
        : datetime.dateToCzechString;
    },
    toT() {
      return this.time
        ? datetime.czechStringToDateTime
        : datetime.czechStringToDate;
    },
    value() {
      return this.$store.getters.getAt(this.paths);
    },
    changed() {
      return this.$store.getters.isChangedAt(this.paths);
    },
    valid() {
      return this.$store.getters.isValidAt(this.paths);
    },

    calendarValue() {
      return this.value != null ? this.value : new Date(2000, 1, 1);
    },
    showedCalendar() {
      return this.currentCalendar != null
        ? this.currentCalendar
        : this.calendarValue;
    },

    label() {
      return this.showedCalendar.toLocaleString(this.localize, {
        month: "long"
      });
    },
    inputValue() {
      if (this.value == null) return null;

      return this.toS(this.value);
    },

    labelsCalendar() {
      let result = [];
      for (let i = 0; i < 7; i++) {
        let name = new Date(
          1970,
          1,
          1 + this.startWeekDay + i
        ).toLocaleDateString(this.localize, { weekday: "short" });
        result.push(name);
      }

      return result;
    },
    daysCalendar() {
      let result = [];
      let currentDay =
        this.currentCalendar != null
          ? this.currentCalendar
          : new Date(
              this.calendarValue.getFullYear(),
              this.calendarValue.getMonth(),
              1
            );
      while (currentDay.getMonth() == this.showedCalendar.getMonth()) {
        result.push(currentDay);
        currentDay = new Date(
          currentDay.getFullYear(),
          currentDay.getMonth(),
          currentDay.getDate() + 1
        );
      }
      return result;
    }
  },
  methods: {
    keypressed(event) {
      var value = this.toT(event.target.value);
      if (value != null) {
        this.$store.commit("update", {
          paths: this.paths,
          value: value
        });
        this.currentCalendar = null;
      }
    },
    select(date) {
      let newDate;
      if (this.value != null) {
        newDate = new Date(this.value.getTime());
        newDate.setFullYear(date.getFullYear());
        newDate.setMonth(date.getMonth());
        newDate.setDate(date.getDate());
      } else {
        newDate = date;
      }

      this.$store.commit("update", {
        paths: this.paths,
        value: newDate
      });
      this.currentCalendar = null;

      if (!this.time) this.hide();
    },
    selectHour(hour) {
      let now = new Date();
      let newDate = this.value != null ? new Date(this.value.getTime()) : new Date(now.getFullYear(), now.getMonth(), now.getDay());
      newDate.setHours(hour);

      this.$store.commit("update", {
        paths: this.paths,
        value: newDate
      });
    },
    selectMinute(minute) {
      let now = new Date();
      let newDate = this.value != null ? new Date(this.value.getTime()) : new Date(now.getFullYear(), now.getMonth(), now.getDay());
      newDate.setMinutes(minute);

      this.$store.commit("update", {
        paths: this.paths,
        value: newDate
      });
    },

    next() {
      let newValue =
        this.currentCalendar != null
          ? this.currentCalendar
          : this.calendarValue;
      this.currentCalendar = new Date(
        newValue.getFullYear(),
        newValue.getMonth() + 1,
        1
      );
    },
    prev() {
      let newValue =
        this.currentCalendar != null
          ? this.currentCalendar
          : this.calendarValue;
      this.currentCalendar = new Date(
        newValue.getFullYear(),
        newValue.getMonth() - 1,
        1
      );
    },

    show() {
      this.showed = true;
    },
    hide() {
      this.showed = false;
    },
    toggle() {
      this.showed = !this.showed;
    },

    wdClass(wd) {
      let date = this.value == null ? new Date() : new Date(
        this.value.getFullYear(),
        this.value.getMonth(),
        this.value.getDate()
      );
      let result = ["wd", `wd-${(wd.getDay() + 7 - this.startWeekDay) % 7}`];
      if (this.value != null && wd.getTime() == date.getTime())
        result.push("selected");
      return result;
    }
  },
  mounted() {
    // close on click
    events.closer(this.$el, this.hide);

    // validation
    if (!this.required) return;

    this.$store.commit("addEventHandler", {
      paths: this.paths,
      id: 'b99a6c6d-b27a-4300-bda0-00335a19969e',
      action: function(type) {
        if (type == "remove") {
          if (!this.valid) {
            this.$store.commit("removeValidationError", {
              paths: this.paths
            });
          }

          return;
        }

        if (this.value != null) {
          if (!this.valid) {
            this.$store.commit("removeValidationError", {
              paths: this.paths
            });
          }
        } else {
          this.$store.commit("addValidationError", {
            paths: this.paths,
            message: `Pole '${this.name}' je povinné`
          });
        }
      }.bind(this)
    });

    // validate now
    if (this.value == null) {
      this.$store.commit("addValidationError", {
        paths: this.paths,
        message: `Pole '${this.name}' je povinné`
      });
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_constants
@import ../sass/_components

// clock
$c: 12

$am_inc_1: $c + 4
$am_inc_2: $c + 7
$am_inc_3: $c + 8
$am_dec_1: $c - 4
$am_dec_2: $c - 7
$am_dec_3: $c - 8

$pm_inc_1: $c + 3
$pm_inc_2: $c + 5
$pm_inc_3: $c + 6
$pm_dec_1: $c - 3
$pm_dec_2: $c - 5
$pm_dec_3: $c - 6

$m_inc_1: $c + 5
$m_inc_2: $c + 9
$m_inc_3: $c + 10
$m_dec_1: $c - 5
$m_dec_2: $c - 9
$m_dec_3: $c - 10

@mixin column_am($column)
  grid-column: $column / span 3
@mixin row_am($row)
  grid-row: $row / span 3

.inputer-date
  position: relative
  @include inputer()
  .holder
    position: absolute
    display: grid
    top: 3rem
    padding: 0.5rem

    background-color: #fff
    border: 1px solid #000
    border-radius: 1rem
    z-index: 10
    grid-template-areas: "prev label next time""calendar calendar calendar time"
    justify-items: center
    &:not(.show)
      display: none

    .prev, .next
      margin: 5px
      padding: 10px 20px
      border-radius: 5px
      cursor: pointer
      transition: background-color .5s
      &:hover
        background-color: $bc-secondary
    .prev
      grid-area: prev
    .next
      grid-area: next
    .label
      grid-area: label
      margin: 5px
      padding: 0.5rem
      text-transform: capitalize
    .calendar
      grid-area: calendar
      justify-self: stretch
      display: grid
      grid-template-columns: repeat(7, 1fr)
      
      .wd, .wd-label
        text-align: center
      .wd
        padding: 5px 10px
        border-radius: 5px
        cursor: pointer
        transition: background-color .5s
        &:hover
          background-color: $bc-secondary
      .selected
        background-color: $bc-primary
      .wd-0
        grid-column: 1
      .wd-1
        grid-column: 2
      .wd-2
        grid-column: 3
      .wd-3
        grid-column: 4
      .wd-4
        grid-column: 5
      .wd-5
        grid-column: 6
      .wd-6
        grid-column: 7
    .time
      grid-area: time
      display: grid

      grid-template-columns: repeat(25, 10px)
      grid-template-rows: repeat(25, 10px)
      align-items: center
      justify-items: center

      border: 2px solid #000
      border-radius: 50%
      .hour
        font-weight: bold
      .hour, .minute
        display: grid
        height: 1.6rem
        width: 1.6rem
        border-radius: 50%
        align-items: center
        justify-items: center
        cursor: pointer
        &:hover
          background-color: #aaa
        &.selected
          color: #fff
          background-color: green
      .minute.hidden
        display: none

      .hour-1
        @include column_am($am_inc_1)
        @include row_am($am_dec_2)
      .hour-2
        @include column_am($am_inc_2)
        @include row_am($am_dec_1)
      .hour-3
        @include column_am($am_inc_3)
        @include row_am($c)
      .hour-4
        @include column_am($am_inc_2)
        @include row_am($am_inc_1)
      .hour-5
        @include column_am($am_inc_1)
        @include row_am($am_inc_2)
      .hour-6
        @include column_am($c)
        @include row_am($am_inc_3)
      .hour-7
        @include column_am($am_dec_1)
        @include row_am($am_inc_2)
      .hour-8
        @include column_am($am_dec_2)
        @include row_am($am_inc_1)
      .hour-9
        @include column_am($am_dec_3)
        @include row_am($c)
      .hour-10
        @include column_am($am_dec_2)
        @include row_am($am_dec_1)
      .hour-11
        @include column_am($am_dec_1)
        @include row_am($am_dec_2)
      .hour-12
        @include column_am($c)
        @include row_am($am_dec_3)
      .hour-13
        @include column_am($pm_inc_1)
        @include row_am($pm_dec_2)
      .hour-14
        @include column_am($pm_inc_2)
        @include row_am($pm_dec_1)
      .hour-15
        @include column_am($pm_inc_3)
        @include row_am($c)
      .hour-16
        @include column_am($pm_inc_2)
        @include row_am($pm_inc_1)
      .hour-17
        @include column_am($pm_inc_1)
        @include row_am($pm_inc_2)
      .hour-18
        @include column_am($c)
        @include row_am($pm_inc_3)
      .hour-19
        @include column_am($pm_dec_1)
        @include row_am($pm_inc_2)
      .hour-20
        @include column_am($pm_dec_2)
        @include row_am($pm_inc_1)
      .hour-21
        @include column_am($pm_dec_3)
        @include row_am($c)
      .hour-22
        @include column_am($pm_dec_2)
        @include row_am($pm_dec_1)
      .hour-23
        @include column_am($pm_dec_1)
        @include row_am($pm_dec_2)
      .hour-0
        @include column_am($c)
        @include row_am($pm_dec_3)

      .minute-5
        @include column_am($m_inc_1)
        @include row_am($m_dec_2)
      .minute-10
        @include column_am($m_inc_2)
        @include row_am($m_dec_1)
      .minute-15
        @include column_am($m_inc_3)
        @include row_am($c)
      .minute-20
        @include column_am($m_inc_2)
        @include row_am($m_inc_1)
      .minute-25
        @include column_am($m_inc_1)
        @include row_am($m_inc_2)
      .minute-30
        @include column_am($c)
        @include row_am($m_inc_3)
      .minute-35
        @include column_am($m_dec_1)
        @include row_am($m_inc_2)
      .minute-40
        @include column_am($m_dec_2)
        @include row_am($m_inc_1)
      .minute-45
        @include column_am($m_dec_3)
        @include row_am($c)
      .minute-50
        @include column_am($m_dec_2)
        @include row_am($m_dec_1)
      .minute-55
        @include column_am($m_dec_1)
        @include row_am($m_dec_2)
      .minute-0
        @include column_am($c)
        @include row_am($m_dec_3)
</style>